export const environment = {
    production: true
}

export const version = '4.5.7'
export const releaseNotes =
    'https://drive.google.com/file/d/1cUKoi57APX6K5MNsbYnx-ydthE_AmurF/view?usp=sharing'

export const apis = {
    baseUrl: 'https://rgv4-beta.repairgenie.net/backend/api/v4',
    //
    googleApiKey: '',
    googleCaptchaSiteKey: ''
}

export const socialLoginUrls = {
    google: `${apis.baseUrl}/public/login/google`,
    facebook: `${apis.baseUrl}/public/login/facebook`
}

export const firebaseConfig = {
    apiKey: 'AIzaSyCMNqCYNd3Z4s5K3bMdLANb6fMVDcIsZew',
    authDomain: 'rgv4-beta.firebaseapp.com',
    projectId: 'rgv4-beta',
    storageBucket: 'rgv4-beta.appspot.com',
    messagingSenderId: '501901413979',
    appId: '1:501901413979:web:14ee597ad91a117127797e',
    measurementId: 'G-D5P0Y84QG0',
    vapidKey:
        'BE6gybCFFvTjOhw0YlRQANK0u2p2ryD2uD4VwMgLgxeE11d1a_dGds4Q98m4yBfaGWhROr4gP26qaxD5lm1qk-M'
}

export const appURL = 'https://rgv4-beta.repairgenie.net/'

/**
 * Reverb (Laravel websockets) used for realtime notifications, e.g. "your export is ready".
 * `key` must match REVERB_APP_KEY of the API. Enable once Reverb is deployed for this
 * environment; until then the app falls back to polling.
 */
export const reverb = {
    enabled: false,
    key: '',
    host: 'rgv4-beta.repairgenie.net',
    port: 443,
    forceTLS: true
}
